/*
  src/redux/passwordReset/reducer.js

  Created by erikchristensen on 11/22/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import update from 'immutability-helper';

const initialState = {};

export default function(state=initialState,action){
  switch(action.type){
  default:
    return update(state,{});
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/passwordReset/reducer.js